import styled from "@emotion/styled"

const ArticleShare = styled.div`
  margin-top: 60px;
`

export default ArticleShare
